export default __webpack_public_path__ + "sounds/beep.mp3";